module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-detail-bill"
  }, [_c('navbar', {
    attrs: {
      "title": "单据统计-明细"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollShow),
      expression: "scrollShow"
    }],
    staticClass: "common-scroll detail-scroll"
  }, [_c('p', {
    staticClass: "detail-bill-status"
  }, [_vm._v("订单号：" + _vm._s(_vm.billCountSerials.trans_bill_no) + "\n\t\t\t"), (_vm.billCountSerials.bill_state == 10) ? _c('span', {
    staticClass: "grey-font"
  }, [(_vm.billCountSerials.urgent_flag == 1) ? _c('i', {
    staticClass: "tips-flag"
  }, [_vm._v("加急")]) : _vm._e(), _vm._v("未处理\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.billCountSerials.bill_state == 11) ? _c('span', {
    staticClass: "aqua-font"
  }, [(_vm.billCountSerials.urgent_flag == 1) ? _c('i', {
    staticClass: "tips-flag"
  }, [_vm._v("加急")]) : _vm._e(), _vm._v("待发货\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.billCountSerials.bill_state == 12) ? _c('span', {
    staticClass: "orange-font"
  }, [(_vm.billCountSerials.urgent_flag == 1) ? _c('i', {
    staticClass: "tips-flag"
  }, [_vm._v("加急")]) : _vm._e(), _vm._v("已发货\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.billCountSerials.bill_state == 20) ? _c('span', {
    staticClass: "grey-font"
  }, [(_vm.billCountSerials.urgent_flag == 1) ? _c('i', {
    staticClass: "tips-flag"
  }, [_vm._v("加急")]) : _vm._e(), _vm._v("未确认\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.billCountSerials.bill_state == 21) ? _c('span', {
    staticClass: "red-font"
  }, [(_vm.billCountSerials.urgent_flag == 1) ? _c('i', {
    staticClass: "tips-flag"
  }, [_vm._v("加急")]) : _vm._e(), _vm._v("已确认\n\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-wrapper"
  }, [_c('h4', {
    staticClass: "detail-bill-address"
  }, [_vm._v(_vm._s(_vm.billCountSerials.from_organ_name))]), _vm._v(" "), _c('ul', {
    staticClass: "detail-bill-list"
  }, _vm._l((_vm.details), function(detail) {
    return _c('li', [_vm._v(_vm._s(detail.goods_name) + "(" + _vm._s(detail.goods_unit) + ")\n\t\t\t\t\t"), _c('ul', {
      staticClass: "detail-bill-sonlist"
    }, [(detail.goods_code) ? _c('li', {
      staticClass: "detail-bill-fulllist"
    }, [_vm._v("品项编号：" + _vm._s(detail.goods_code))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("订货数量：" + _vm._s(_vm._f("numFixed")(detail.goods_num, _vm.numScale)))]), _vm._v(" "), _c('li', [_vm._v("发货数量：" + _vm._s(_vm._f("numFixed")(detail.goods_num_send, _vm.numScale)))]), _vm._v(" "), _c('li', [_vm._v("税率：" + _vm._s(detail.goods_cess) + " %")]), _vm._v(" "), _c('li', [_vm._v("含税单价：" + _vm._s(_vm._f("numFixed")(detail.goods_price_send, _vm.numScale)) + "元")]), _vm._v(" "), _c('li', [_vm._v("价税合计：" + _vm._s(_vm._f("numFixed")(detail.sub_total_send, _vm.numScale)) + "元")]), _vm._v(" "), _c('li', [_vm._v("实收数量：" + _vm._s(_vm._f("numFixed")(detail.goods_num_recipient, _vm.numScale)))]), _vm._v(" "), _c('li', [_vm._v("实收金额：" + _vm._s(_vm._f("numFixed")(detail.sub_total_recipient, _vm.numScale)) + "元")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (detail.goods_assist_unit),
        expression: "detail.goods_assist_unit"
      }]
    }, [_c('li', {
      staticClass: "detail-bill-twolist"
    }, [_vm._v("辅助单位：" + _vm._s(detail.goods_assist_unit))]), _vm._v(" "), _c('li', {
      staticClass: "detail-bill-twolist"
    }, [_vm._v("退货辅助数量：" + _vm._s(_vm._f("numFixed")(detail.goods_assist_num, 4)))])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollShow),
      expression: "scrollShow"
    }],
    staticClass: "detail-bill-footer"
  }, [_c('div', {
    staticClass: "detail-bill-info"
  }, [_c('p', [_vm._v("配送至：\n\t\t\t\t"), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "all-font"
  }, [_vm._v(_vm._s(_vm.allInfo))]), _vm._v(" "), _c('i', {
    staticStyle: {
      "width": "auto"
    },
    on: {
      "click": function($event) {
        return _vm.showAll('配送至：' + _vm.billCountSerials.to_organ_name)
      }
    }
  }, [_vm._v(_vm._s(_vm.billCountSerials.to_organ_name))])]), _vm._v(" "), _c('p', [_vm._v("总计：\n\t\t\t\t"), _c('i', {
    staticStyle: {
      "width": "auto"
    },
    on: {
      "click": function($event) {
        _vm.showAll('总计：' + (_vm.numScale ? _vm.billCountSerials.sum_money_send.toFixed(_vm.numScale) : _vm.billCountSerials.sum_money_send) + '元')
      }
    }
  }, [_vm._v(_vm._s(_vm._f("numFixed")(_vm.billCountSerials.sum_money_send, _vm.numScale)) + "元")])]), _vm._v(" "), _c('p', [_vm._v("退货辅助数量：\n\t\t\t\t"), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "all-font"
  }, [_vm._v(_vm._s(_vm.allInfo))]), _vm._v(" "), _c('i', {
    staticStyle: {
      "width": "auto"
    },
    on: {
      "click": function($event) {
        return _vm.showAll('退货辅助数量：' + _vm.sumGoodsAssistNumReturn)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("numFixed")(_vm.sumGoodsAssistNumReturn, 4)))])])])]), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-67fac388!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BillCountSerialDetail.vue
// module id = 584
// module chunks = 1